module.exports = __webpack_public_path__ + "giftbox.7fcc3a482e33624d0175c07261c1259b.svg";